import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { URLsConfig } from '../URLsConfig';
import { MedicalHistoryModel } from '../models/MedicalHistoryModel';
@Injectable()
export class MedicalHistoryService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getMHistory(patientCode: string , comCode: string) {
      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", comCode);
        const options = {
            params: params
        };
        return this.http.get<MedicalHistoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/MedicalHistory/GetMHistory',options);
    }
    public AddMHistory(MHistory: MedicalHistoryModel) {
      console.log("MHistory:"+ MHistory);
        return this.http.post<MedicalHistoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/MedicalHistory/AddMHistory', MHistory);
    }
    public delMHistory(patientCode: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("patientCode", patientCode);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.delete<MedicalHistoryModel>(this.urlsconfig.WebAPIURL_Test + 'api/MedicalHistory/DeleteMHistory',options);
    }


}
